import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { EmbeddedEffects } from './embedded.effects';
import { initialState, reducer } from './embedded.reducer';
import { createLocalStorageSyncReducer } from '../local-storage-sync';
import { EmbeddedState } from './embedded.state';
import { getEnvironment } from '../../features/shared/utils/get-environment';

const syncMetaReducer = createLocalStorageSyncReducer<EmbeddedState>({
  keys: ['collapsedTopics'],
  rehydrate: true,
  storage: localStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-embedded-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('embedded', reducer, { initialState, metaReducers: [syncMetaReducer] }),
    EffectsModule.forFeature([EmbeddedEffects]),
  ],
  providers: [EmbeddedEffects],
})
export class EmbeddedStoreModule {}
